import { useMemo } from 'react'
import { detect } from 'detect-browser'

export const useGetBrowserProperties = () => {
  const browser = detect()

  const isWebView = browser && (browser?.name.includes('webview') || browser?.name.includes('wv'))

  const { isAndroid, isIphone } = useMemo(
    () => ({
      isAndroid: browser?.os === 'Android OS',
      isIphone: browser?.os === 'iOS',
    }),
    [browser],
  )

  return { isWebView, isAndroid, isIphone }
}
